enum Language {
  Dutch = 'NL',
  English = 'EN',
  German = 'DE',
}

export default Language;
